import { Link } from "react-router-dom";
import { newsList } from "@/mocks/news";
import SectionHeading from "@/components/base/SectionHeading";

export default function NewsPreview() {
  const latest = [...newsList]
    .sort((a, b) => (a.date < b.date ? 1 : -1))
    .slice(0, 4);

  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
      <SectionHeading
        eyebrow="Newsroom"
        title="最新资讯"
        description="剧情资料更新、行业动态与官方消息，第一时间了解仙侠影视的最新动向。"
        action={
          <Link
            to="/news"
            className="inline-flex items-center gap-2 h-10 px-5 rounded-md bg-secondary-500 hover:bg-secondary-600 text-background-50 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer"
          >
            进入资讯专题
            <i className="ri-arrow-right-line"></i>
          </Link>
        }
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        {latest.map((item) => (
          <Link
            key={item.id}
            to="/news"
            className="group flex flex-col sm:flex-row gap-4 p-3 md:p-4 rounded-lg border border-background-200 bg-background-50 hover:border-primary-300 transition-colors"
          >
            <div className="w-full sm:w-40 h-40 sm:h-28 rounded-md overflow-hidden shrink-0 bg-background-200">
              <img
                src={item.cover}
                alt={item.title}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="min-w-0 flex flex-col">
              <div className="flex items-center gap-2">
                <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-800 text-[11px]">
                  {item.category}
                </span>
                <span className="text-xs text-foreground-400">{item.date}</span>
              </div>
              <h3 className="mt-2 text-sm md:text-base font-medium text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
                {item.title}
              </h3>
              <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                {item.summary}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}